<template>
  <tr class="no_edit">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @change="onChange"
             :checked="isChecked"
             @click.stop
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Firmware' | translate" class="first_data">{{ entity.firmware }}</td>
    <td :data-th="'Aplikace' | translate">{{ entity.application }}</td>
    <td :data-th="'Profil zařízení' | translate">{{ entity.device_profile }}</td>
    <td :data-th="'Typ zařízení' | translate">{{ entity.device_type }}</td>
    <td :data-th="'Datum změny' | translate" v-html="$_date_formatFull(entity.timestamp_created)" />
    <td class="no_padding"></td>
  </tr>
</template>

<script>
	export default {
		name: "DeviceHistoryRow",
		props: {
			entity: Object,
      selectedEntities: Array,
		},
		methods: {
      onChange: function (e) {
        this.$emit('input', e)
      },
		},
    computed: {
      isChecked() {
        return this.selectedEntities.indexOf(String(this.entity.id)) > -1
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceHistoryRow.vue